import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IMrpUpdatePostBody, IMrpUpdatePostReponse } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { setMRPUpdate } from "@/app_redux/reducers/slices/auth/inventory_slice";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useMRPUpdateAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: IMrpUpdatePostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(INVENTORY_MODULE?.MRP_UPDATE?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IMrpUpdatePostReponse>) => {
            if (res.data.status === true) {
              dispatch(setMRPUpdate({ data: res.data.data }));
              return { status: true, message: "batch" };
            } else {
              dispatch(setMRPUpdate({ data: null }));
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(setMRPUpdate({ data: null }));
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        dispatch(setMRPUpdate({ data: null }));
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
